<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="130px">
        <el-row>
          <el-col span="12">
            <el-form-item label="电表表号：">
              <el-input v-model="rowData.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="当前余额：">
              <el-input v-model="rowData.balance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="chargeAmount"
              label="充值金额："
              :rules="[{ required: true, message: '请输入充值金额', trigger: 'blur' }]"
            >
              <moneyInput
                v-model="formData.chargeAmount"
                placeholder="请输入 充值金额"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="chargeOrReadTime"
              label="充值时间："
              :rules="[{ required: true, message: '请输入充值时间', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="formData.chargeOrReadTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">修改</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { rechargeApi } from '@/api/electric-meter/electric-meter-management';

export default {
  props: ['rowData'],
  data() {
    return {
      // 表单数据
      formData: {
        chargeAmount: 0,
        chargeOrReadTime: '',
      },
    };
  },
  computed: {
    reduceAmount() {
      if (this.formData.unitPrice && this.formData.endNum) {
        return this.formData.unitPrice * (this.formData.endNum - this.rowData.lastEndNum);
      }
    },
  },
  created() {
    this.formData = Object.assign(
      {},
      {
        id: this.rowData.id,
        chargeOrReadTime: this.dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      }
    );
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.formData.chargeAmount) {
            this.$message.error('充值金额必须大于0');
            return;
          }
          rechargeApi(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
